import React, { useState } from 'react';
import Login from './auth/Login.js';
const Register = React.lazy(() => import('./auth/Register.js'));
const Dashboard = React.lazy(() => import('./Dashboard.js'));
const Home = React.lazy(() => import('./Dashboard.js').then(module => ({ default: module.Home })));
const EditProfile = React.lazy(() => import('./EditProfile.js'));
const Settings = React.lazy(() => import('./Settings.js'));
import School, { SchoolHome } from './school/School.js';
import Logout from './auth/Logout.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { isLoggedIn, Menu } from '../utils/Auth.js';
const Activate = React.lazy(() => import('./auth/Activate.js'));

const Accounts = React.lazy(() => import('./accounts/Accounts.js'));
const AccountsMenu = React.lazy(() => import('./accounts/Accounts.js').then(module => ({ default: module.AccountsMenu })));

const SchoolSettings = React.lazy(() => import('./settings/SchoolSettings.js'));
const SettingsMenu = React.lazy(() => import('./settings/SchoolSettings.js').then(module => ({ default: module.SettingsMenu })));
const SettingsRoute = React.lazy(() => import('./settings/SchoolSettings.js').then(module => ({ default: module.SettingsRoute })));
const Forgot = React.lazy(() => import('./auth/Forgot.js'));
const Bot = React.lazy(() => import('./Bot.js'));

import UserContext from '../utils/UserContext.js';

const Reset = React.lazy(() => import('./auth/Reset.js'));

// const CBT_Direct = React.lazy(() => import('./CBT/CBT_Direct.js'));

import { useQuery } from '@apollo/client';
import { GET_CONFIG } from '../Graphql/School.js';
import { Loading } from './PageElements.js';
import Session from '../utils/Session.js';
const Feedback = React.lazy(() => import('./Feedback.js'));

const FeedbackMessages = React.lazy(() => import('./FeedbackMessages.js'));



const CBTSpreadsheet = React.lazy(() => import('./CBT/CBTSpreadsheet.js'));

const App = () => {
  const loggedIn = isLoggedIn();
  const [user, setUser] = useState({});
  const [school, setRealSchool] = useState(Session.object('school') || {});
  const [objects, setRealObjects] = useState(Session.object('objects') || {});

  const setSchool = (s) => {
    setRealSchool(s);
    Session.setObject('school', s);
  };

  const setObjects = (s) => {
    setRealObjects(s);
    Session.setObject('objects', s);
  };

  useQuery(GET_CONFIG, {
    fetchPolicy: 'cache-and-network', //cache-first, cache-only, cache-and-network, network-only, no-cache, standby
    onCompleted: data => {
      setObjects(values => ({ ...values, CONFIG: data.getConfig }));
      Session.setObject('LINKS', data.getConfig.links);
    },
    // eslint-disable-next-line no-unused-vars
    onError: error => {
    }
  });

  if (!loggedIn) {
    return (
      <Router>
        <Routes>
          <Route path={'/register'} element={<React.Suspense fallback={<Loading />}>
            <Register />
          </React.Suspense>} />
          <Route path={'/activate'} element={<React.Suspense fallback={<Loading />}>
            <Activate />
          </React.Suspense>} />
          <Route path={'/logout'} element={<Logout />} />
          <Route path={'/forgot'} element={<React.Suspense fallback={<Loading />}>
            <Forgot />
          </React.Suspense>} />
          <Route path={'/reset'} element={<React.Suspense fallback={<Loading />}>
            <Reset />
          </React.Suspense>} />
          <Route
            path="*"
            element={<Login />}
          />
        </Routes>
      </Router>
    );
  } else return (
    <UserContext.Provider value={{
      user,
      setUser,
      school,
      setSchool,
      objects,
      setObjects
    }}>
      <Router>
        <Routes>
          <Route path={'/'} element={<React.Suspense fallback={<Loading />}>
            <Dashboard />
          </React.Suspense>} />
          <Route path={'/login'} element={<Login />} />
          <Route path={'/logout'} element={<Logout />} />
          <Route path={'/dashboard/*'} element={<React.Suspense fallback={<Loading />}>
            <Dashboard />
          </React.Suspense>} >
            <Route index element={<React.Suspense fallback={<Loading />}>
              <Home />
            </React.Suspense>} />
            <Route path=":resourceId" element={<React.Suspense fallback={<Loading />}>
              <Home />
            </React.Suspense>} />
          </Route>

          <Route path={'/editprofile'} element={<React.Suspense fallback={<Loading />}>
            <EditProfile />
          </React.Suspense>} />
          <Route path={'/bot'} element={<React.Suspense fallback={<Loading />}>
            <Bot />
          </React.Suspense>} />
          <Route path={'/settings'} element={<React.Suspense fallback={<Loading />}>
            <Settings />
          </React.Suspense>} />
          <Route path={'/feedback'} element={<React.Suspense fallback={<Loading />}>
            <Feedback />
          </React.Suspense>} />
          <Route path={'/feedbackmessage/*'} element={<React.Suspense fallback={<Loading />}>
            <FeedbackMessages />
          </React.Suspense>} >
            <Route index element={<React.Suspense fallback={<Loading />}>
              <FeedbackMessages />
            </React.Suspense>} />
            <Route path=":resourceId" element={<React.Suspense fallback={<Loading />}>
              <FeedbackMessages />
            </React.Suspense>} />
          </Route>
          <Route path={'/school'} element={<School />} >
            <Route index element={<Menu />} />

            <Route path="cbt-results/:cbtID" element={<React.Suspense fallback={<Loading />}>
              <CBTSpreadsheet />
            </React.Suspense>} />
            <Route path=":resourceId" element={<SchoolHome />} />
          </Route>
          <Route path={'/accounts'} element={<React.Suspense fallback={<Loading />}>
            <Accounts />
          </React.Suspense>} >
            <Route index element={<React.Suspense fallback={<Loading />}>
              <AccountsMenu />
            </React.Suspense>} />
            <Route path=":resourceId" element={<React.Suspense fallback={<Loading />}>
              <AccountsMenu />
            </React.Suspense>} />
          </Route>
          {/* <Route path={'/cbt'} element={<React.Suspense fallback={<Loading />}>
            <CBT_Direct />
          </React.Suspense>} >
            <Route index element={<React.Suspense fallback={<Loading />}>
              <CBT_Direct />
            </React.Suspense>} />
            <Route path=":resourceId" element={<React.Suspense fallback={<Loading />}>
              <CBT_Direct />
            </React.Suspense>} />
          </Route> */}

          <Route path={'/schoolsettings'} element={<React.Suspense fallback={<Loading />}>
            <SchoolSettings />
          </React.Suspense>} >
            <Route index element={<React.Suspense fallback={<Loading />}>
              <SettingsMenu />
            </React.Suspense>} />
            <Route path=":resourceId" element={<React.Suspense fallback={<Loading />}>
              <SettingsRoute />
            </React.Suspense>} />
          </Route>
          <Route
            path="*"
            element={<Dashboard />}
          />
        </Routes>
      </Router>
    </UserContext.Provider>
  );

};

export default App;
